import {
	functionalUpdate,
	makeStateUpdater,
	type OnChangeFn,
	type RowData,
	type Table,
	type TableFeature,
	type Updater,
} from '@tanstack/svelte-table'

// define types for our new feature's custom state
export type LaunchedState = 'date' | 'age'
export interface LaunchedStateTableState {
	launchedState: LaunchedState
}

// define types for our new feature's table options
export interface LaunchedStateOptions {
	onLaunchedStateChange?: OnChangeFn<LaunchedState>
}

// Define types for our new feature's table APIs
export interface LaunchedStateInstance {
	setLaunchedState: (updater: Updater<LaunchedState>) => void
	toggleLaunchedState: (value?: LaunchedState) => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LaunchedStateFeature: TableFeature<any> = {
	getInitialState: (state): LaunchedStateTableState => {
		return {
			launchedState: 'date',
			...state,
		}
	},

	getDefaultOptions: <TData extends RowData>(table: Table<TData>): LaunchedStateOptions => {
		return {
			onLaunchedStateChange: makeStateUpdater('launchedState', table),
		} as LaunchedStateOptions
	},

	createTable: <TData extends RowData>(table: Table<TData>): void => {
		table.setLaunchedState = updater => {
			const safeUpdater: Updater<LaunchedState> = old => {
				const newState = functionalUpdate(updater, old)

				return newState
			}

			return table.options.onLaunchedStateChange?.(safeUpdater)
		}

		table.toggleLaunchedState = value => {
			table.setLaunchedState(old => {
				if (value) {
					return value
				}

				return old === 'date' ? 'age' : 'date'
			})
		}
	},
}

export const LAUNCHED_STATES: LaunchedState[] = ['age', 'date']
